import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../services';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { FilterPopupChipsModel } from '../models/filter-popup-chips.model';
import { ShipmentEndpoint } from '../shipment/constants/shipment-endpoint';

@Injectable({
  providedIn: 'root',
})
export class StatusCodeService {
  constructor(private http: WrapperHttpService) {}

  getStatusCode(): Observable<FilterPopupChipsModel[]> {
    const url = `${API_URL}${ShipmentEndpoint.Filters}${ShipmentEndpoint.Common}${ShipmentEndpoint.Enums}${ShipmentEndpoint.StatusCodes}`;
    return this.http.withLoading().get<FilterPopupChipsModel[]>(url);
  }
}
